import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs';
import { Artist } from 'src/app/_models/artist.model';
import { ArtistService } from 'src/app/_services/artist.service';
import { SwiperOptions } from 'swiper/types';
import { ArtistCarouselItemComponent } from './artist-item/artist-item.component';


@Component({
    selector: 'app-artist-carousel',
    templateUrl: './artist-carousel.component.html',
    styleUrls: ['./artist-carousel.component.scss'],
    standalone: false
})
export class ArtistCarouselComponent implements OnInit {
  @ViewChildren('itemSwiper') itemSwiper: QueryList<ArtistCarouselItemComponent>;
  public config: SwiperOptions = null;
  public subscriptions: Subscription[] = [];
  public artists: Artist[] = null;

  constructor(public artistService: ArtistService) { }

  ngOnInit(): void {
    this.subscriptions.push(this.artistService.artists.subscribe(
      artists => {
        if (artists) {
          this.artists = artists;
          this.config = {
            resizeObserver: true,
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: false,
            pagination: false,
            loop: true,
            autoplay: false,
            effect: 'cube'
          };
        }
      }
    ));
  }

  public slideNext(){
    this.itemSwiper?.forEach((itemSwiper => {
      itemSwiper.slideNext();
    }));
  }
  public slidePrev(){
    this.itemSwiper?.forEach((itemSwiper => {
      itemSwiper.slidePrev();
    }));
  }
}

